import HomeHeroBannerUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/HomeHeroBanner/HomeHeroBanner'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

type Props = UIProps

const HomeHeroBanner = (props: Props) => {
  const analytics = useAnalytics()

  const homeHeroCTAnalytics = (category: string) => {
    analytics.homeHeroBanner(category)
  }

  useLoaded(props)

  return <HomeHeroBannerUI {...props} homeHeroCTAnalytics={homeHeroCTAnalytics} />
}

export default HomeHeroBanner
